import { useMediaQuery } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import { erasmusRequests } from "api/erasmusApi";
import { settings } from "app";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import { MobileListRow } from "features/MobileListRow";
import {
  Datagrid,
  EditButton,
  FunctionField,
  List,
  ListActions,
  NumberInput,
  ReferenceField,
  ShowButton,
  SimpleList,
  TextField,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT } from "utils/constants";
import DeleteCoordinatorDialog from "./components/DeleteDialog";
import { getCoordinatorName } from "./utils";

const listFilters = [
  <NumberInput
    source="id"
    label="ID"
    alwaysOn
  />,
];

const ListErasmusCoordinators = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  return (
    <List
      sx={settings.style.blockStyle}
      exporter={false}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canManageErasmusCoordinators)} />}
      filters={listFilters}
      title="Координатори"
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "ID", value: <TextField source="id" /> }]} />
              <MobileListRow fields={[{ label: "Служител", value: getCoordinatorName(record) }]} />
            </div>
          )}
          secondaryText={() => (
            <MobileListRow
              fields={[
                {
                  label: "Структурна единица",
                  value: (
                    <ReferenceField
                      source="structuralUnitId"
                      reference={administrationRequests.getStructuralUnitsSelect()}
                    >
                      <TextField source="name" />
                    </ReferenceField>
                  ),
                },
                {
                  label: "Статус",
                  value: (
                    <ReferenceField
                      source="status"
                      reference={erasmusRequests.getCoordinatorStatusesSelect()}
                    >
                      <TextField source="nameBg" />
                    </ReferenceField>
                  ),
                },
              ]}
            />
          )}
          tertiaryText={record => (
            <>
              <SecuredComponent permission={permissions.canManageErasmusCoordinators}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewErasmusCoordinators}>
                <ShowButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canManageErasmusCoordinators}>
                <DeleteCoordinatorDialog
                  id={record.id}
                  name={getCoordinatorName(record)}
                  label=""
                />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            source="id"
            label="ID"
            sortable={false}
          />
          <FunctionField
            label="Служител"
            render={getCoordinatorName}
            sortable={false}
          />
          <ReferenceField
            label="Структурна единица"
            source="structuralUnitId"
            reference={administrationRequests.getStructuralUnitsSelect()}
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            label="Статус"
            source="status"
            reference={erasmusRequests.getCoordinatorStatusesSelect()}
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <SecuredComponent permission={permissions.canManageErasmusCoordinators}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewErasmusCoordinators}>
            <ShowButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canManageErasmusCoordinators}>
            <FunctionField
              label=""
              render={record => (
                <DeleteCoordinatorDialog
                  id={record.id}
                  name={getCoordinatorName(record)}
                />
              )}
            />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListErasmusCoordinators;
